import React from 'react';

/**
 * App-level error boundary with Sentry integration.
 * Shows a full-page error UI with dev mode error details.
 * Reports errors to Sentry when available (loaded lazily via window.Sentry).
 */
class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Application error:', error, errorInfo);

    if (window.Sentry) {
      window.Sentry.captureException(error, {
        extra: { componentStack: errorInfo?.componentStack }
      });
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          padding: '2rem'
        }}>
          <h2>出现问题了</h2>
          <p style={{ color: '#64748b', marginBottom: '1.5rem' }}>
            发生了意外错误。请尝试刷新页面，如果问题仍然存在，请联系支持团队。
          </p>
          {import.meta.env.MODE === 'development' && this.state.error && (
            <pre style={{
              color: '#dc2626',
              background: '#fef2f2',
              padding: '1rem',
              borderRadius: '8px',
              maxWidth: '600px',
              overflow: 'auto'
            }}>
              {this.state.error.message}
            </pre>
          )}
          <button
            style={{
              marginTop: '2rem',
              padding: '0.75rem 1.5rem',
              background: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontWeight: 500,
              cursor: 'pointer',
              fontSize: '1rem'
            }}
            onClick={this.handleReset}
          >
            刷新页面
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export function SentryErrorBoundary({ children }) {
  return <AppErrorBoundary>{children}</AppErrorBoundary>;
}
